<template>
  <ds-row>
    <ds-col size="12">
      <ds-fieldset title="Alocações no Período" />
      <ds-field label="Deseja fazer alocação por: " />
      <ds-radio-group
        v-model="allocationTypeSelected"
        required
        @click="onAllocationTypeChange">
        <ds-radio
          v-for="typeOption in allocationTypes"
          :key="typeOption.instance.name"
          :value="typeOption.instance.name">
          {{ typeOption.instance.description }}
        </ds-radio>
      </ds-radio-group>
    </ds-col>

    <ds-col>
      <ds-inline-table
        :value="localAllocations"
        :min-required-lines="1"
        button-text="Adicionar funcionário"
        button-column-size="3"
        @change="onAllocationsChanged">
        <ds-inline-table-th slot="header" required>Funcionário</ds-inline-table-th>
        <ds-inline-table-th slot="header" required>
          {{ allocationTypeRule.instance.description }}
        </ds-inline-table-th>

        <template #default="{index}">
          <ds-inline-table-td
            id="employee"
            size="6"
            required
            :component-is="EmployeeSearchSelect"
            :component-options="{
              required: true,
              key:index,
              index: index,
              competence: competence,
              allocations: localAllocations,
            }">
          </ds-inline-table-td>
          <ds-inline-table-td
            id="allocationValue"
            required
            :component-options="allocationTypeRule.componentOptions"
            :component-is="allocationTypeRule.type">
          </ds-inline-table-td>
        </template>
      </ds-inline-table>
    </ds-col>
  </ds-row>
</template>

<script>
import {
  buildComponentRules,
  reloadComponentRules,
  getFirstAndLastDaysOfMonth,
  validateMinMax,
  clearAllocationValues,
} from '../../serviceTakerAllocationService';
import { SERVICE_TAKER_ALLOCATION_FIELDS_RULES, SERVICE_TAKER_ALLOCATION_TYPES } from '../../constants';
import EmployeeSearchSelect from './EmployeeSearchSelect';

export default {
  name: 'ServiceTakerEmployeeInlineTable',
  props: {
    competence: {
      type: String,
      required: true,
    },
    allocationType: {
      type: Object,
      required: true,
    },
    allocations: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      EmployeeSearchSelect,
      allocationTypeSelected: this.allocationType.name,
      allocationTypeRule: SERVICE_TAKER_ALLOCATION_FIELDS_RULES[this.allocationType.value],
      allocationTypes: buildComponentRules(
        this.validateDayInput,
        this.validateHourInput,
        this.validatePercentInput
      ),
      localAllocations: this.buildInitialAllocations(),
    };
  },
  watch: {
    allocations(value) {
      this.localAllocations = value;
    },
    allocationType(value) {
      this.allocationTypeSelected = value.name;
      this.allocationTypeRule = this.allocationTypes[value.name];
    },
  },
  methods: {
    async onAllocationTypeChange(allocationType) {
      const allocations = JSON.parse(JSON.stringify(this.localAllocations));

      this.localAllocations = [];
      await this.$nextTick();

      this.localAllocations = clearAllocationValues(allocations);
      this.$emit('update:allocationType', SERVICE_TAKER_ALLOCATION_TYPES[allocationType]);
    },
    onAllocationsChanged(allocations) {
      this.$emit('update:allocations', allocations);
    },
    validateDayInput(value) {
      return validateMinMax(this.allocationTypes.DAY.limits, Number(value));
    },
    validateHourInput(value) {
      if (value.toString().length < 6) return false;
      const [hour, minute] = String(value).split(':');
      if (Number(hour) === 227 && Number(minute) > 33) return false;
      return validateMinMax(this.allocationTypes.HOUR.limits, Number(hour));
    },
    validatePercentInput(value) {
      return validateMinMax(this.allocationTypes.PERCENTAGE.limits, value);
    },
    reloadRules(newCompetence) {
      reloadComponentRules(
        this.allocationTypes,
        this.allocationTypes.DAY.instance.name,
        getFirstAndLastDaysOfMonth(newCompetence)
      );
    },
    buildInitialAllocations() {
      return this.allocations?.length ? this.allocations : [];
    },
  },
};
</script>
